"use strict";

var jQueryEcounter = 0,
    jQueryCounter = 0; // This is to only run jQuery once it's loaded.

window.defer = function (method) {
  jQueryCounter++;

  if (window.jQuery) {
    method();
  } else if (jQueryCounter <= 50) {
    setTimeout(function () {
      return window.defer(method);
    }, 50);
  }
};

window.deferJqueryE = function (method) {
  jQueryEcounter++;

  if (window.jQueryE) {
    method();
  } else if (jQueryEcounter <= 50) {
    setTimeout(function () {
      return window.deferJqueryE(method);
    }, 50);
  } else {
    document.getElementsByClassName('purchase-details')[0].innerHTML += '<p style="color:red;">An error occured, please try refreshing the page. Not supported on Internet Explorer.</p>';
  }
}; // Make sure we have the right basket item count - excluding giftwrap


window.getItemCount = function (originalItemCount, itemList) {
  var actualItemCount = parseInt(originalItemCount);
  itemList.children().each(function (i, item) {
    if (item.classList.contains('is-giftwrap')) {
      var quantityElement = itemList.find("div[data-cart-item=\"".concat(/lineItemKey:(\s)(.*)/.exec(item.innerHTML)[2], "\"] .quantity-input.quantity-element.input"))[0];
      if (undefined !== quantityElement) actualItemCount = actualItemCount - parseInt(quantityElement.value);
    }
  });
  return actualItemCount;
}; // Add css/js scripts asynchronously. Returns html in case you need to wait for an onload event.
// Array: urls
// Boolean: isStyleSheet
// String: delay


window.addScripts = function (urls) {
  var isStylesheet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  return urls.map(function (url) {
    var html = document.createElement(isStylesheet ? 'link' : 'script'),
        scripts = document.getElementsByTagName('script')[0];
    if (isStylesheet) html.rel = 'stylesheet';
    isStylesheet ? html.href = url : html.src = url;
    setTimeout(function () {
      return scripts.parentNode.insertBefore(html, scripts);
    }, delay);
    return html;
  });
}; // Fix banner height.


window.resizeBanner = function (oldImageHeight) {
  return setTimeout(function () {
    var image = document.querySelector('[alt="Banner Image"]');
    oldImageHeight === image.height ? (document.getElementById('announcement-bar').style.height = image.height + 'px', document.getElementById('announcement-bar__shadow').style.height = image.height + 'px') : window.resizeBanner(image.height);
  }, 200);
};

window.fixVideoHeight = function (videoId) {
  window[videoId] = document.getElementById(videoId);

  window[videoId].oncanplaythrough = function () {
    window[videoId].classList.remove('video-min');
    window[videoId].oncanplaythrough = null;
  };
};

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('[alt="Banner Image"]')) window.resizeBanner(document.querySelector('[alt="Banner Image"]').height);
  document.querySelectorAll('#q').forEach(function (element, i) {
    return element.id = 'q' + i;
  });
});
"use strict";

//Make a graphql request
window.graphQLRequest = function (query) {
  return $.ajax({
    type: 'POST',
    url: 'https://firebox.com/api/2020-10/graphql',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': 'afa803f1bb9b661611feef329010d0cb'
    },
    data: query
  });
};
"use strict";

window.checkStickers = function (title, handle, stickers) {
  if (stickers && stickers[0] && (null === stickers[0].lastElementChild || -1 !== stickers[0].innerHTML.toLowerCase().indexOf('firebox loves') || -1 !== stickers[0].innerHTML.indexOf(Shopify.translation.pre_order) || -1 !== stickers[0].innerHTML.indexOf('Exclusive') || -1 !== stickers[0].innerHTML.indexOf('Firebox Creations') || -1 !== stickers[0].innerHTML.indexOf(Shopify.translation.sale))) stickers.forEach(function (sticker) {
    return sticker.innerHTML = "<div class=\"new-sticker thumbnail-sticker sticker-\"><span class=\"sticker-text\">".concat(Shopify.translation.new_sticker, "</span></div>");
  });
};